<template>
  <div class="step-progress--wrapper">
    <div class="step-progress--wrapper-before"/>
    <div class="step-progress--bar">
      <div
        v-for="(step, index) in steps"
        :key="index"
        :class="['step-progress--step', {
          'step-progress--step--active': index === currentStep,
          'step-progress--step--valid': index < currentStep
        }]"
      >
        <img
          v-if="index === steps.length - 1"
          src="/static/svg/trophy.svg"
          class="trophy"
        >
        <span v-if="index >= currentStep"/>
        <b-icon
          v-else
          size="is-small"
          icon="check"
          type="is-white"
        />
        <div :class="['step-icon']"/>
        <div class="step-label">{{ step }}</div>
      </div>
    </div>
    <div
      :style="{
        transform: &quot; scaleX(&quot; + scaleX + &quot;) translateY(-50%) perspective(1000px)&quot;
      }"
      class="step-progress--wrapper-after"
    />
  </div>
</template>

<script>
export default {
  name: 'StepProgress',
  props: {
    steps: {
      type: Array,
      default () { return [] },
      validator (val) {
        return val && val.length > 0
      }
    },
    currentStep: {
      type: Number,
      default: 0
    }
  },
  computed: {
    scaleX () {
      let step = this.currentStep
      if (step < 0) {
        step = 0
      } else if (step >= this.steps.length) {
        step = this.steps.length - 1
      }
      return step / (this.steps.length - 1)
    }
  }
}
</script>

<style scoped lang="scss">
.step-progress {
  &--wrapper {
    width: 75%;
    margin: 0 auto;
    position: relative;
    z-index: 0;
  }
  &--wrapper-before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    height: 4px;
    width: 100%;
    background-color: #d9d9d9;
    transform: translateY(-50%) perspective(1000px);
  }
  &--wrapper-after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    height: 4px;
    width: 100%;
    background-color: #0564c4;
    transform: scaleX(0) translateY(-50%) perspective(1000px);
    transform-origin: left center;
    transition: transform 1s ease;
  }
  &--bar {
    width: 100%;
    display: flex;
    height: 100px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
  }
  &--step {
    z-index: 2;
    position: relative;
    span {
      color: #d9d9d9;
      transition: 1s ease;
      display: block;
      font-weight: 900;
      text-align: center;
      opacity: 1;
      width: 20px;
      height: 20px;
    }
    &--active {
      span {
        width: 20px;
        height: 20px;
        background-color: #0564c4;
        border-radius: 50%;
      }
      .step-label {
        color: #000000;
      }
      .step-icon {
        opacity: 1;
      }
    }
    &--valid {
      span {
        color: #0564c4;
        transform: translate3d(0, 0, 0) scale(2) perspective(1000px);
      }
      .step-icon {
        opacity: 1;
        transform: translate3d(-50%, -50%, 0) scale(1) perspective(1000px);
      }
      .step-label {
        color: #000000;
      }
    }
  }
}
.step-progress--step:after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) perspective(1000px);
  width: 40px;
  height: 40px;
  background-color: #d9d9d9;
  border-radius: 50%;
  border: 5px solid #d9d9d9;
  transition: 1s ease;
}
.step-progress--step--active:after {
  background-color: #fff;
  border: 5px solid #0564c4;
}
.step-progress--step--valid:after {
  background-color: #0564c4;
  border: 5px solid #0564c4;
}
.step-label {
  position: absolute;
  top: calc(100% + 15px);
  left: 50%;
  transform: translateX(-50%) perspective(1000px);
  white-space: nowrap;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  transition: 1s ease;
}
.trophy {
  position: absolute;
  top: -70px;
  left: -15px;
  max-width: none;
}
@media (max-width: 768px) {
  .step-progress--step span {
    font-size: 15px;
  }
  .step-progress--step:after {
    width: 40px;
    height: 40px;
  }
  .step-icon {
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Steps.vue